var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7632 8.20465L10.6215 1.02147C10.5588 0.977038 10.4851 0.950706 10.4084 0.945354C10.3318 0.940001 10.2551 0.955834 10.1869 0.991121C10.1186 1.02641 10.0614 1.07979 10.0214 1.14542C9.98143 1.21106 9.96029 1.28642 9.96028 1.36326V5.27401L9.79918 5.33593C6.7847 6.49526 3.8757 8.19033 2.02125 10.9101C1.83254 11.1868 1.65667 11.4718 1.49364 11.7649C0.957695 12.7373 0.566399 13.7826 0.332106 14.868C0.0670789 16.0702 -0.0224495 17.3059 0.00393049 18.535C0.00595826 18.6256 0.0373271 18.7131 0.0933255 18.7844C0.149324 18.8556 0.226929 18.9068 0.314483 18.9302C0.402038 18.9535 0.494815 18.9479 0.578881 18.914C0.662947 18.8802 0.733761 18.82 0.780689 18.7425C2.7187 15.5386 5.69625 12.2261 9.69358 11.9818L9.9602 11.9655V15.7293C9.96027 15.8061 9.98144 15.8814 10.0214 15.947C10.0614 16.0126 10.1186 16.066 10.1869 16.1013C10.2551 16.1365 10.3317 16.1524 10.4084 16.1471C10.485 16.1417 10.5587 16.1155 10.6214 16.0711L20.7632 8.88799C20.8179 8.84931 20.8624 8.7981 20.8932 8.73865C20.9239 8.6792 20.9399 8.61325 20.9399 8.54632C20.9399 8.47939 20.9239 8.41344 20.8932 8.35399C20.8624 8.29454 20.8179 8.24333 20.7632 8.20465Z",
    fill: "#B9C4E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.464304056a8374b5a3b702cae5246db4.svg";
export { ForwardRef as ReactComponent };